import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

// Layout
import Layout from "@/components/layout/Layout";

// Pages
import HomePage from "@/pages/HomePage";
import PlatformPage from "@/pages/PlatformPage";
import ProductsPage from "@/pages/ProductsPage";
import HowItWorksPage from "@/pages/HowItWorksPage";
import IndustriesPage from "@/pages/IndustriesPage";
import InsightsPage from "@/pages/InsightsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BlogPostPage from "@/pages/BlogPostPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CommunityPage from "@/pages/CommunityPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="min-h-screen bg-[#020617]">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#0B1426',
              border: '1px solid rgba(0, 180, 216, 0.3)',
              color: '#F8FAFC',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="platform" element={<PlatformPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="products/:productId" element={<ProductsPage />} />
            <Route path="how-it-works" element={<HowItWorksPage />} />
            <Route path="industries" element={<IndustriesPage />} />
            <Route path="insights" element={<InsightsPage />} />
            <Route path="insights/:slug" element={<BlogPostPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="community" element={<CommunityPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
